import { render } from "./NavbarCH.vue?vue&type=template&id=1b4a1656"
import script from "./NavbarCH.vue?vue&type=script&lang=js"
export * from "./NavbarCH.vue?vue&type=script&lang=js"

import "./NavbarCH.vue?vue&type=style&index=0&id=1b4a1656&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__